export type Tone = 'light' | 'dark' | 'original'

export interface ColorMatrixEffect {
  type: 'colorMatrix'
  values: number[][]
}

export function getGrayscaleMatrix(tone: Tone = 'light'): ColorMatrixEffect {
  const isLight = tone === 'light'

  // Standard grayscale luminance weights
  const lumR = 0.33
  const lumG = 0.59
  const lumB = 0.11

  // Shift determines brightness:
  // Light tone → brighten dark logo colors
  // Dark tone → darken light logo colors
  const shift = isLight ? 0.7 : -0.7

  return {
    type: 'colorMatrix',
    values: [
      [lumR, lumG, lumB, 0, shift],
      [lumR, lumG, lumB, 0, shift],
      [lumR, lumG, lumB, 0, shift],
      [0, 0, 0, 1, 0],
    ],
  }
}
